module.exports = __webpack_public_path__ + "img/textBlock.769521c0.png";